import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import ControlledGrid from '../Helper/ControlledGrid';
import GeometryGrid from '../Helper/GeometryGrid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import MotCle from './MotCle';
import Thematique from './Thematique';


class Station extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Station";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}

  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de la station.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idStation" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idStation")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="nom">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Nom</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("nom")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Thematique ManyToMany */}
          <PermissionCheck component={Thematique.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="thematiques">
            <Col componentClass={ControlLabel} sm={2}>Thématiques</Col>
            <Col sm={6}>
              <ControlledGrid ref="thematiquesGrid" path="thematiques" objectPath={"stations_thematiques/" + this.state.object.idStation + "/thematiques"}
              objectClass={Thematique} mode={this.state.mode} cbxUrl={REST_API_URL + "stations_thematiques/" + this.state.object.idStation + "/thematiques/inverse/"}
              optionValueKey="idThematique" optionLabelKey="libelle" />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* MotCle ManyToMany */}
          <PermissionCheck component={MotCle.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="motCles">
            <Col componentClass={ControlLabel} sm={2}>Mots clé</Col>
            <Col sm={6}>
              <ControlledGrid ref="motclesGrid" path="motcles" objectPath={"stations_motcles/" + this.state.object.idStation + "/motcles"} objectClass={MotCle}
              mode={this.state.mode} cbxUrl={REST_API_URL + "stations_motcles/" + this.state.object.idStation + "/motcles/inverse/"} optionValueKey="idMotCle"
              optionLabelKey="libelle" />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Geom OneToMany */}
          {(this.state.mode !== "add") &&
            <GeometryGrid title="Géométries" path="stations_geoms" objectPath={"stations_geoms/" + this.getObjectProperty("idStation")} objectClass={Station} mode={this.state.mode}
              queryLayers={"StationCreate"} allowDraw={true} selectionMultiple={true} typeGeometry="point" withImportCsv={false} withImportPoint={true} />
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" &&
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup>
          }
  			</Form>

      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idStation";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let stationObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.thematiquesGrid !== undefined) stationObj.thematiques = this.refs.thematiquesGrid.getArrayToSave();
      if(this.refs.motclesGrid !== undefined) stationObj.motCles = this.refs.motclesGrid.getArrayToSave();
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(stationObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Station sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Station créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/stations/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.thematiquesGrid !== undefined) this.refs.thematiquesGrid.saveAll();
    if(this.refs.motclesGrid !== undefined) this.refs.motclesGrid.saveAll();
  }

}

export default Station;



// WEBPACK FOOTER //
// ./src/views/Entity/Station.js